module.exports = __webpack_public_path__ + "static/media/upscale.656e7887.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/images/visual-electric/features/upscale.mp4
// module id = 370
// module chunks = 0